import { createSlice, PayloadAction, type WithSlice } from '@reduxjs/toolkit';
import type { ReactNode } from 'react';
import type { PageDataState } from './pageData.types';
import { registerSliceInjection } from '@starjack/api';

const initialState: PageDataState = {
    explanationVideo: null,
    pageDescription: null,
};

export const pageDataSlice = createSlice({
    name: 'requestSlice',
    initialState: initialState,
    reducers: {
        setExplanationVideo: (
            state: PageDataState,
            action: PayloadAction<string>
        ) => {
            state.explanationVideo = action.payload;

            return state;
        },

        setPageData: (
            state: PageDataState,
            action: PayloadAction<{
                title: string;
                body: ReactNode;
            }>
        ) => {
            state.pageDescription = action.payload;

            return state;
        },

        resetPageData: () => {
            return initialState;
        },
    },
});

export const pageDataActions = {
    ...pageDataSlice.actions,
};

// Auto-inject pageDataSlice when this module is imported
// This happens automatically - no need to call any initialization function
registerSliceInjection((rootReducer) => {
    pageDataSlice.injectInto(rootReducer);
});

// Auto-augment the global type registry
declare module '@starjack/api' {
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
    export interface LazyLoadedSlicesRegistry extends WithSlice<
        typeof pageDataSlice
    > {}
}
